<div class="diagram-wrapper">
  <rappider-diagram-toolbar [(menuVisibility)]="menuVisibility"
                            [zoomLevel]="zoomLevel"
                            [startNodeId]="startNodeId"
                            [starterNodes]="starterNodes"
                            (menuVisibilityChange)="onMenuVisibilityChange($event)"
                            (createWorkflowEvent)="onCreateWorkflowEventButtonClick()"
                            (refreshWorkflowData)="refreshSyncedRemoteData()"
                            (createStepFunction)="onCreateStepFunctionButtonClick()"
                            (zoomLevelChanged)="onZoomLevelChanged($event)"
                            (starterNodeSelected)="onStarterNodeSelected($event)"
                            (zoomToFit)="centerDiagram()"></rappider-diagram-toolbar>

  <!-- DIAGRAM AREA -->
  <div class="diagram-area">

    <!-- STARTER NODE FILTER DROPDOWN -->
    <!-- <div class="starter-node-filter-container">
      <nz-select [(ngModel)]="startNodeId"
                 (ngModelChange)="onStarterNodeSelected($event)"
                 nzPlaceHolder="Filter by workflow"
                 nzAllowClear
                 [nzShowSearch]="true"
                 class="starter-node-select">
        <nz-option *ngFor="let node of starterNodes"
                   [nzValue]="node.id"
                   [nzLabel]="node.name"></nz-option>
      </nz-select>
    </div> -->

    <!-- SPLIT CONTAINER -->
    <as-split direction="horizontal"
              unit="pixel"
              gutterSize="10">
      <!-- Diagram Area -->
      <as-split-area [minSize]="600">
        <div id="diagram-container"
             class="diagram-container">
        </div>
        <div *ngIf="!isDiagramBuilt"
             class="loading-icon">
          <i class="fa-duotone fa-spinner fa-spin"></i> <span class="loading-text">Loading Diagram...</span>
        </div>

      </as-split-area>
      <!-- Settings Area - Right Side Bar -->
      <as-split-area [size]="menuVisibility ? 600 : 0"
                     [minSize]="200"
                     class="diagram-settings-split-area">
        <div class="diagram-settings-container">
          <!-- Step Function Type Selector -->
          <ng-container *ngIf="viewMode === SettingViewMode.FunctionTypeSelector">

            <div class="add-node-container">
              <section>
                <h3>Add Step Function</h3>
                <p>
                  Please select a step function type to add to the workflow. You can customize the step function
                  settings
                  later
                </p>
              </section>
              <rappider-menu [config]="STEP_FUNCTION_TYPE_SELECTOR_MENU"
                             [showLabels]="true"
                             (menuItemClick)="functionTypeSelectorMenuItemClicked($event)"></rappider-menu>
            </div>

          </ng-container>

          <!-- Integration Functions List -->
          <ng-container *ngIf="viewMode === SettingViewMode.IntegrationFunctions">
            <div class="add-node-container">
              <section>
                <h3>Integration & Function Library</h3>
                <p>
                  Please select a function to add to the workflow. You can customize the
                  function settings later
                </p>
                <div class="section-toolbar">
                  <rappider-button [text]="'Back'"
                                   [size]="'small'"
                                   [icon]="{name: 'fa-regular fa-arrow-left'}"
                                   (confirm)="displayStepFunctions()">
                  </rappider-button>
                </div>
              </section>
              <rappider-menu [config]="integrationFunctionTemplateSelectorMenu"
                             [showLabels]="true"
                             (menuItemClick)="functionFromLibrarySelected($event)"></rappider-menu>
            </div>
          </ng-container>

          <!-- AI Generated Custom Function Form -->
          <ng-container *ngIf="viewMode === SettingViewMode.AIGeneratedCustomFunction">
            <div class="add-node-container">
              <section>
                <h3>Generate Step Function with Assistant</h3>
                <p>
                  Please describe the step function you want to create. The AI will generate a custom function based on
                  your description.
                  You can customize the step function settings later.
                </p>
                <div class="section-toolbar">
                  <rappider-button [text]="'Back'"
                                   [size]="'small'"
                                   [icon]="{name: 'fa-regular fa-arrow-left'}"
                                   (confirm)="displayStepFunctions()">
                  </rappider-button>
                </div>
              </section>
              <rappider-crud-view-edit-form [config]="createCustomFunctionWithAIFormConfig"
                                            (formSubmit)="onCreateCustomFunctionWithAIFormSubmit($event)">
              </rappider-crud-view-edit-form>

            </div>
          </ng-container>

          <!-- Project Endpoints Form -->
          <ng-container *ngIf="viewMode === SettingViewMode.ProjectEndpoints">
            <div class="add-node-container">
              <section>
                <h3>Call A Project Endpoint</h3>
                <p>
                  Please select a project endpoint to add to the workflow. You can customize the endpoint settings
                  later.
                </p>
                <div class="section-toolbar">
                  <rappider-button [text]="'Back'"
                                   [size]="'small'"
                                   [icon]="{name: 'fa-regular fa-arrow-left'}"
                                   (confirm)="displayStepFunctions()">
                  </rappider-button>
                </div>
                <rappider-crud-view-edit-form [config]="selectProjectEndpointFormConfig"
                                              [data]="{projectEndpointId: selectedWorkflowStepFunction?.projectEndpoint?.id}"
                                              [dynamicDataForSelectBox]="projectEndpointOptions"
                                              (formSubmit)="onSelectProjectEndpointFormSubmit($event)">
                </rappider-crud-view-edit-form>

              </section>
            </div>
          </ng-container>

          <!-- FORMS -->
          <ng-container>
            <!-- Workflow Event Settings -->
            <ng-container *ngIf="viewMode === SettingViewMode.WorkflowEventSettings">
              <rappider-workflow-event-wrapper [submitButtonLoading]="eventFormSubmitButtonLoading"
                                               [cancelButtonLoading]="eventFormCancelButtonLoading"
                                               [eventMode]="eventMode"
                                               [workflowEvent]="selectedWorkflowEvent"
                                               [workflowEventDeleteAllWorkflowConfig]="workflowEventDeleteAllWorkflowButtonConfig"
                                               (eventNameChange)="onEventNameChangeOnCreate($event)"
                                               (editWorkflowEvent)="onEditWorkflowEvent($event)"
                                               (createWorkflowEvent)="onCreateWorkflowEvent($event)"
                                               (deleteEvent)="onDeleteEvent($event)"
                                               (deleteWorkflow)="onDeleteWorkflow($event)"></rappider-workflow-event-wrapper>
            </ng-container>

            <!-- Workflow Step Function Settings -->
            <ng-container *ngIf="viewMode === SettingViewMode.WorkflowStepFunctionSettings">
              <div class="form-area workflow-step-function-editor-form">
                <section class="heading-area">
                  <rappider-heading [content]="stepFunctionMode === WorkflowStepFunctionMode.Create ? 'New ' + workflowStepFunctionFormHeading.content : 'Edit ' + workflowStepFunctionFormHeading.content"
                                    [type]="workflowStepFunctionFormHeading.type"></rappider-heading>
                </section>
                <div class="form">
                  <rappider-workflow-step-function-form [data]="stepFunctionMode === WorkflowStepFunctionMode.Create ? initialStepFunctionData : selectedWorkflowStepFunction"
                                                        [formLayout]="formLayout"
                                                        [isSubmitButtonVisible]="false"
                                                        (nameChange)="onStepFunctionNameChangeOnCreate($event)"
                                                        (selectedMode)="onModeChange($event)"
                                                        (workflowStepFunctionFormSubmit)="onStepFunctionFormSubmit($event)"></rappider-workflow-step-function-form>


                  <!-- CUSTOM FUNCTION FORM -->
                  <ng-container
                                *ngIf="selectedWorkflowStepFunction.mode === 'custom-function-definition' && selectedWorkflowStepFunction?.customFunction?.id">
                    <section>
                      <h5>
                        <i class="fa-regular fa-code"></i>&nbsp;Code
                      </h5>
                    </section>
                    <rappider-custom-function-edit *ngIf="selectedWorkflowStepFunction?.customFunction?.id"
                                                   [activeCustomFunctionId]="selectedWorkflowStepFunction?.customFunction?.id"
                                                   [displayToolbar]="false"
                                                   [updateFormData]="selectedWorkflowStepFunction?.customFunction"
                                                   [hideFields]="customFunctionFormHiddenFields"
                                                   [hideSubmitButton]="true"
                                                   [formLayout]="'vertical'"
                                                   (updateFormChanged)="onCustomFunctionUpdateFormChangedValue($event)"
                                                   (updateFormSubmit)="onCustomFunctionUpdateFormSubmit($event)"></rappider-custom-function-edit>
                  </ng-container>
                  <!-- END of CUSTOM FUNCTION FORM -->

                  <!-- AI FUNCTION FORM -->
                  <ng-container
                                *ngIf="selectedWorkflowStepFunction.mode === 'ai-function' && selectedWorkflowStepFunction?.aiFunction">
                    <section>
                      <h5>
                        <i class="fa-regular fa-code"></i>&nbsp;AI Function Settings
                      </h5>
                    </section>
                    <rappider-crud-view-edit-form [config]="aiFunctionCallEntityConfig?.config?.updateItemFormConfig"
                                                  [data]="selectedWorkflowStepFunction?.aiFunction"
                                                  (formValueChange)="onAIFunctionUpdateFormValueChange($event)"
                                                  (formSubmit)="onAIFunctionUpdateFormSubmit($event)">
                    </rappider-crud-view-edit-form>
                  </ng-container>
                  <!-- END of AI FUNCTION FORM -->

                  <!-- ENDPOINT FORM -->
                  <ng-container *ngIf="selectedWorkflowStepFunction.mode === 'endpoint'">
                    <section>
                      <h5>
                        <i class="fa-regular fa-plug"></i>&nbsp;Endpoint Settings
                      </h5>
                    </section>
                    <rappider-crud-view-edit-form [config]="selectProjectEndpointFormConfig"
                                                  [data]="selectedWorkflowStepFunction?.projectEndpoint"
                                                  [dynamicDataForSelectBox]="projectEndpointOptions"
                                                  (formSubmit)="onSelectProjectEndpointFormSubmit($event)">
                    </rappider-crud-view-edit-form>
                  </ng-container>
                  <!-- END of ENDPOINT FORM -->
                </div>
              </div>

              <!-- Footer -->
              <section class="workflow-step-function-editor-footer">
                <rappider-button [text]="workflowStepFunctionDeleteButtonConfig.text"
                                 [loading]="eventFormCancelButtonLoading"
                                 [popconfirmTitle]="workflowStepFunctionDeleteButtonConfig.popconfirmTitle"
                                 [emitWithoutPopconfirm]="workflowStepFunctionDeleteButtonConfig.emitWithoutPopconfirm"
                                 [popconfirmCancelText]="workflowStepFunctionDeleteButtonConfig.popconfirmCancelText"
                                 [popconfirmOkText]="workflowStepFunctionDeleteButtonConfig.popconfirmOkText"
                                 [popconfirmOkDanger]="workflowStepFunctionDeleteButtonConfig.popconfirmOkDanger"
                                 (confirm)="onStepFunctionDeleteButtonClicked()"></rappider-button>
                <rappider-button [text]="'Save'"
                                 [type]="'primary'"
                                 (confirm)="onStepFunctionSaveButtonClicked()">
                </rappider-button>
              </section>

            </ng-container>
          </ng-container>
          <!-- END of forms -->
        </div>
        <!-- END of diagram-settings-container -->
      </as-split-area>
    </as-split>

  </div>

  <!-- Data Transformation Modal -->
  <rappider-modal [(visible)]="dataTransformationModalVisibility"
                  [fullScreen]="true"
                  [title]="'Data Transformation'"
                  (okClick)="toggleDataTransformationModalVisibility()"
                  (cancelClick)="toggleDataTransformationModalVisibility()">
    <rappider-workflow-step-function-data-transformation *ngIf="dataTransformationModalVisibility"
                                                         [isLoading]="isDataTransformationLoading"
                                                         [dataTransformationId]="dataTransformationId"
                                                         [sourceSchema]="sourceSchema"
                                                         [targetSchema]="targetSchema"></rappider-workflow-step-function-data-transformation>
  </rappider-modal>

  <!-- Comments Section -->
  <ng-template #commentsTemplate
               let-data="ngArguments">
    <div class="comment-component-wrapper">
      <rappider-comment-wrapper [activePerson]="data.activePerson"
                                [peopleData]="data.peopleData"
                                [comments]="data.comments"
                                [isLoading]="data.isLoading"
                                (createComment)="onCreateComment($event)"
                                (editComment)="onEditComment($event)"
                                (deleteComment)="onDeleteComment($event)"></rappider-comment-wrapper>
    </div>
  </ng-template>
</div>
